import React, { useEffect, useState } from "react";
import AdminLayout from "./Common/AdminLayout";
import { Link } from "react-router-dom";
import { CreateFolder, GetFolder, searchAllFolders} from "../../Redux/Slices/Folder";
import "../../asset/new/css/admin-modern.css";

const AdminFolder = () => {
  const [data, setData] = useState("");
  const [folders, setFolders] = useState([]);
  const [limit, setLimit] = useState(10);


  //Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    let inputData = { name: data };
    await CreateFolder(inputData);
    handlefolder();
  };

  // Folder List
  const handlefolder = async () => {
    let data = await GetFolder();   
    setFolders(data);
  };


  const searchFolders = async (data) => {
    try {
      const res = await searchAllFolders({ data });
      setFolders(res);
    } catch (error) {
      console.error("Error fetching sales history:", error);
    } 
  };

  const handlePageChange = async (page) => {
    let data = {
      page:page,
      search:"",
      limit:limit
    };
    searchFolders(data);
  };

  const handleSearch = (e) => {
    let data = {
      page:1,
      search:e.target.value,
      limit:limit
    };
    searchFolders(data)
    
  };

  const selectFoldersLength = (e) => {
    setLimit(e.target.value);
    let data = {
      page:1,
      search:"",
      limit:e.target.value
    };
    searchFolders(data)
  };


  useEffect(() => {
    handlefolder();
    document.title = "Folder | Admin";

  }, []);

  // Calculate visible page range
  let startPage = 1;
  let endPage = 1;

  if (folders?.pagination) {
    startPage = Math.max(1, folders.pagination.page - 2);
    endPage = Math.min(
      folders.pagination.totalPages,
      folders.pagination.page + 2
    );

    // Adjust start and end page if close to beginning or end
    if (folders.pagination.page <= 3) {
      endPage = Math.min(5, folders.pagination.totalPages);
    } else if (folders.pagination.page >= folders.pagination.totalPages - 2) {
      startPage = Math.max(1, folders.pagination.totalPages - 4);
    }
  }

  return (
    <AdminLayout
      title="Manage Folders"
      subtitle="Organize candidate profiles into folders"
      actions={
        <button
          type="button"
          className="admin-btn admin-btn-primary"
          data-bs-toggle="modal"
          data-bs-target="#addFolderModal"
        >
          <i className="fas fa-plus me-2"></i>
          Add Folder
        </button>
      }
    >
      {/* Table Controls */}
      <div className="admin-card" style={{ marginBottom: 'var(--spacing-xl)' }}>
        <div className="admin-card-body">
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
            <div>
              <label className="me-2">Show</label>
              <select
                className="admin-select d-inline-block"
                style={{ width: "auto" }}
                onChange={(e) => selectFoldersLength(e)}
              >
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
              <span className="ms-2">entries</span>
            </div>
            <input
              type="search"
              placeholder="Search folders..."
              className="admin-input"
              style={{ maxWidth: "300px" }}
              onChange={(e) => handleSearch(e)}
            />
          </div>
        </div>
      </div>

      {/* Folders Table */}
      <div className="admin-card">
        <div className="admin-card-body">
          <div className="admin-table-wrapper">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Folder Name</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {folders?.docs && folders.docs.length > 0 ? (
                  folders.docs.map((item, index) => (
                    <tr key={item._id || index}>
                      <td>
                        <span className="admin-badge admin-badge-light">
                          {(folders.pagination?.page - 1) * (folders.pagination?.limit || 10) + index + 1}
                        </span>
                      </td>
                      <td>
                        <div className="d-flex align-items-center">
                          <i className="fas fa-folder text-warning me-2"></i>
                          <span>{item?.name}</span>
                        </div>
                      </td>
                      <td>
                        <Link
                          to={`/admin/subfolder/${item?._id}`}
                          className="admin-btn admin-btn-sm admin-btn-primary"
                        >
                          <i className="fas fa-folder-open me-1"></i>
                          View Folder
                        </Link>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3">
                      <div className="admin-empty-state">
                        <i className="fas fa-folder-open fa-3x mb-3"></i>
                        <h4>No Folders</h4>
                        <p>Create your first folder to organize candidate profiles.</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {folders?.pagination && folders.docs && folders.docs.length > 0 && (
            <div className="admin-pagination">
              <button
                className="admin-pagination-btn"
                onClick={() => handlePageChange(folders.pagination.prevPage)}
                disabled={!folders.pagination.prevPage}
              >
                <i className="fas fa-chevron-left"></i>
                Previous
              </button>

              <div className="admin-pagination-numbers">
                {Array.from(
                  { length: Math.min(folders.pagination.totalPages, 5) },
                  (_, i) => {
                    const startPageNum = Math.max(1, folders.pagination.page - 2);
                    return startPageNum + i;
                  }
                )
                  .filter((page) => page <= folders.pagination.totalPages)
                  .map((page) => (
                    <button
                      key={page}
                      className={`admin-pagination-number ${folders.pagination.page === page ? "active" : ""}`}
                      onClick={() => handlePageChange(page)}
                    >
                      {page}
                    </button>
                  ))}
              </div>

              <button
                className="admin-pagination-btn"
                onClick={() => handlePageChange(folders.pagination.nextPage)}
                disabled={!folders.pagination.nextPage}
              >
                Next
                <i className="fas fa-chevron-right"></i>
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Add Folder Modal */}
      <div
        className="modal fade"
        id="addFolderModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Add New Folder
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <form>
                <div className="mb-3">
                  <label htmlFor="folderName" className="form-label">
                    Folder Name
                  </label>
                  <input
                    onChange={(e) => setData(e.target.value)}
                    name="name"
                    type="text"
                    className="form-control"
                    placeholder="Enter folder name"
                    id="folderName"
                  />
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="admin-btn admin-btn-secondary"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                onClick={handleSubmit}
                type="button"
                className="admin-btn admin-btn-primary"
                data-bs-dismiss="modal"
              >
                Create Folder
              </button>
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminFolder;
